import React from 'react';
import { FaTwitter, FaFacebookF, FaPinterestP, FaInstagram, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaArrowRight, FaSearch } from 'react-icons/fa';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer-modern">
      <div className="footer-modern__bg">
        <div className="footer-modern__circle-tl"></div>
        <div className="footer-modern__circle-br"></div>
      </div>
      
      <div className="footer-modern__container">
        {/* Top Header */}
        <div className="footer-modern__top">
          <div className="footer-modern__brand">
            <div className="footer-modern__logo-icon">
              <FaSearch size={18} />
            </div>
            <span className="footer-modern__brand-text">Prof. JMR</span>
          </div>
          <div className="footer-modern__social">
            <a href="#" aria-label="Twitter"><FaTwitter /></a>
            <a href="#" aria-label="Facebook"><FaFacebookF /></a>
            <a href="#" aria-label="Pinterest"><FaPinterestP /></a>
            <a href="#" aria-label="Instagram"><FaInstagram /></a>
          </div>
        </div>
        
        <div className="footer-modern__divider"></div>

        {/* Main Content Grid */}
        <div className="footer-modern__grid">
          {/* About Column */}
          <div className="footer-modern__col">
            <h4 className="footer-modern__title">About</h4>
            <p className="footer-modern__text">
              Dedicated to advancing the field of Chemistry through rigorous research, teaching, and administrative leadership.
            </p>
            <form className="footer-modern__newsletter" onSubmit={(e) => e.preventDefault()}>
              <input type="email" placeholder="Email Address" required />
              <button type="submit" aria-label="Subscribe"><FaArrowRight /></button>
            </form>
          </div>

          {/* Explore Column */}
          <div className="footer-modern__col">
            <h4 className="footer-modern__title">Explore</h4>
            <ul className="footer-modern__links">
              <li><a href="#about">About Prof. JMR</a></li>
              <li><a href="#research">Research & Experience</a></li>
              <li><a href="#publications">Publications</a></li>
              <li><a href="#students">Students</a></li>
              <li><a href="#patents">Patents & Books</a></li>
            </ul>
          </div>

          {/* News Column */}
          <div className="footer-modern__col">
            <h4 className="footer-modern__title">News</h4>
            <div className="footer-modern__news-list">
              <div className="footer-modern__news-item">
                <div className="placeholder-img" style={{ background: 'url(https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&q=80&w=100) center/cover' }}></div>
                <div className="footer-modern__news-content">
                  <a href="#">Guest Lecture at Andhra University</a>
                  <span className="footer-modern__news-date">10 Oct, 2024</span>
                </div>
              </div>
              <div className="footer-modern__news-item">
                <div className="placeholder-img" style={{ background: 'url(https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&q=80&w=100) center/cover' }}></div>
                <div className="footer-modern__news-content">
                  <a href="#">New Patent Granted on Nanomaterials</a>
                  <span className="footer-modern__news-date">24 Sep, 2024</span>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Column */}
          <div className="footer-modern__col">
            <h4 className="footer-modern__title">Contact</h4>
            <ul className="footer-modern__contact-list">
              <li>
                <div className="contact-icon"><FaEnvelope /></div>
                <div className="contact-info">
                  <strong>Email</strong>
                  <a href="mailto:professorjaganmohanreddychem@aknu.edu.in">professorjaganmohanreddychem@aknu.edu.in</a>
                </div>
              </li>
              <li>
                <div className="contact-icon"><FaPhoneAlt /></div>
                <div className="contact-info">
                  <strong>Phone</strong>
                  <span>+91-9347153270</span>
                </div>
              </li>
              <li>
                <div className="contact-icon"><FaMapMarkerAlt /></div>
                <div className="contact-info">
                  <strong>Address</strong>
                  <span>Department of Chemistry, AKNU<br/>Rajahmundry, AP - 533 296</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-modern__bottom">
          <p>© {new Date().getFullYear()} Prof. Dr. B. Jagan Mohan Reddy. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
